<template>
  <div class="orders-container">
    <el-table :data="orders" style="width: 100%" v-loading="loading">
      <el-table-column prop="orderNumber" label="订单号" width="180" />
      <el-table-column prop="title" label="商品名称"  width="260" />
      <el-table-column prop="amount" label="金额" width="120">
        <template slot-scope="scope">
          ¥{{ scope.row.amount }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="120">
        <template >
          <el-tag type="success">
            已支付
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="payTime" label="支付时间" width="180" />
    </el-table>
  </div>
</template>

<script>
import { orderApi } from '@/utils/api';

export default {
  name: 'OrdersPage',
  data() {
    return {
      orders: [],
      loading: true
    };
  },
  created() {
    this.fetchOrders();
  },
  methods: {
    async fetchOrders() {
      try {
        const response = await orderApi.getOrders();
        this.orders = response.data;
        this.loading = false;
      } catch (error) {
        this.$message.error('获取订单失败: ' + error.message);
        this.loading = false;
      }
    },
  }
};
</script>

<style scoped>
.orders-container {
  padding: 20px;
}
.orders-page {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 80px);
}
</style>
